<template>
    <div>
        <v-title :title="`${value.referralType}安排信息`" style="margin-left: -15px"></v-title>
        <el-form ref="form" :model="form" :disabled="readonly" label-width="100px" label-position="left">
            <el-form-item label="安排转诊医生:">
                <span class="mr10">{{form.acceptHosName}}</span>
                <span class="mr10">{{form.acceptDeptName}}</span>
                <span class="mr10">{{form.acceptDocName}}</span>
            </el-form-item>

            <el-form-item label="安排转诊时间:">
                <span class="mr10">{{form.date}}</span>
                <span class="mr10">{{form.time}}</span>
            </el-form-item>
            <hos_tip content="此安排时间仅供参考，如有变动会随时通知。"></hos_tip>
            <el-form-item label="医生备注:" style="color:red;">
                {{form.remark}}
            </el-form-item>

            <!--<el-row :gutter="20">-->
                <!--<el-col :span="6">-->
                    <!--<el-form-item label="转诊医院">-->
                        <!--<el-input v-model="form.acceptHosName"></el-input>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->
                <!--<el-col :span="6">-->
                    <!--<el-form-item label="转诊科室">-->
                        <!--<el-input v-model="form.acceptDeptName"></el-input>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->
                <!--<el-col :span="6">-->
                    <!--<el-form-item label="转诊医生">-->
                        <!--<el-input v-model="form.acceptDocName"></el-input>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->
            <!--</el-row>-->
            <!--<el-row>-->
                <!--<el-col :span="6">-->
                    <!--<el-form-item label="转诊时间">-->
                        <!--<el-input v-model="form.date"></el-input>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->
                <!--<el-col :span="3">-->
                    <!--<el-form-item label="" label-width="10px">-->
                        <!--<el-input v-model="form.time"></el-input>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->
            <!--</el-row>-->
        </el-form>
    </div>
</template>

<script>
  import VTitle from "../common/v-title";
  import hos_tip from "../../components/hos/hos-tip"
  import {isEmpty, timeFormat} from "../../lib/utils";

  export default {
    name: "referral-arrange-form",
    props: {
      readonly: {
        type: Boolean,
        default: false
      },
      value: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    data() {
      return {
        form: {}
      }
    },
    created() {
      this.setForm();
    },
    components: {VTitle,hos_tip},
    watch: {
      value: {
        handler() {
          this.setForm();
        },
        deep: true
      }
    },
    methods: {
      setForm() {
        if (!isEmpty(this.value)) {
          this.form = {...this.value};
          let {acceptTime} = this.form;
          if (acceptTime) {
            this.$set(this.form, 'date', timeFormat(acceptTime, '%Y-%m-%d'));
            this.$set(this.form, 'time', timeFormat(acceptTime, '%H:%M:%S'));
          }
        }
      }
    },
  }
</script>

<style scoped>

</style>
